import type { SubTemplateProps } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'

export function HackernewsSlideTemplate({ sub, display, controls, slots }: SubTemplateProps) {
  return (
    <>
      <div className={`md-subs-hackernews-row bg-[#f6f6ef] px-1 pb-1 pt-px font-[Verdana,Geneva,sans-serif] text-[10pt] text-black${display.isChecked ? ' md-subs-hackernews-row--checked bg-[#ffffdd]' : ''}`}>
        <div className="md-subs-hackernews-title flex min-w-0 items-baseline gap-1">
          <span className="text-[#828282]">{sub.subNumber || display.elId}.</span>
          {controls.actions.check}
          <span className="min-w-0 overflow-hidden text-ellipsis whitespace-nowrap [&_.md-sub-title-link]:font-normal [&_.md-sub-title-link]:text-black">{controls.content.title}</span>
        </div>
        <div className="md-subs-hackernews-subtext ml-8 mt-px flex flex-wrap items-center gap-x-1 text-[8pt] text-[#828282] [&_.md-sub-meta-link]:text-[#828282] [&_.md-sub-meta-more]:text-[#828282] [&_.md-sub-text]:inline [&_.md-sub-text]:clear-none [&_.md-sub-text]:text-[#828282]">
          {controls.content.text}
          {controls.content.time}
          {controls.links.answers}
          {controls.links.submsges}
          {controls.actions.favorite}
          {controls.actions.quickReply}
        </div>
      </div>
      <div className="md-subs-hackernews-children ml-10 bg-[#f6f6ef]">{slots.allChildren}</div>
    </>
  )
}
